var Menu = {
  init: function () {
    Debug.log("___ MENU INIT ___");

    $(window).resize(function () {
      Menu.resize();
    });
    Menu.resize();

    $(".header .burger").on("click touchend", function (e) {
      if (e.type == "touchend") {
        $(this).off("click");
      }
      setTimeout(function(){
        Menu.open_menu();
      }, 40);
    });
    $(".header .submenu-link").find("a").on("click touchend", function(e){
      Debug.log("CLICK ON ME : " + $(this).attr("href"));
      window.location.replace($(this).attr("href"));
    })
    $(".header .menu-container.level-2").find("a").on("click touchend", function(e){
      Debug.log("CLICK ON ME : " + $(this).attr("href"));
      window.location.replace($(this).attr("href"));
    })
    $(".header .overlay").on("click touchend", function (e) {
      if (e.type == "touchend") {
        $(this).off("click");
      }

      setTimeout(function(){
        Menu.open_menu();
      }, 40);
    });

    $(".header .bt-close").on("click touchend", function (e) {
      if (e.type == "touchend") {
        $(this).off("click");
      }
      if ($('.header').hasClass('submenu-open')) {

        setTimeout(function(){

          Menu.close_submenu();
        }, 40);
      } else {

        setTimeout(function(){
          Menu.close_menu();
        }, 40);
      }
    });

    $(".header .menu-container.level-0")
      .find(".menu-item-has-children")
      .on("click touchend", function (e) {

        if($(".header .burger").css("display") != "none"){
          console.log("PREVENT DEFAULT WITH CHILDREN");
          e.preventDefault();
        }

        if (e.type == "touchend") {
          $(this).off("click");
        }

        Menu.open_submenu($(this));
      });

    $(".help_menu_link a").on("click touchend", function(e){
      if(e.type == "touchend"){
        $(this).off("click");
      }
      console.log("CLICK BTN LINK : " + $(this).attr("href"));
      window.location.href = $(this).attr("href");
    })
  },
  open_menu: function () {
    Debug.log("OPEN MENU");
    $("html").addClass("menu-open");
    $("body").addClass("no-scroll");
    $(".header").addClass("open");
  },
  close_menu: function () {
    Debug.log("CLOSE MENU");
    Menu.close_submenu();
    $("html").removeClass("menu-open");
    $("body").removeClass("no-scroll");
    $(".header").removeClass("open");
  },
  open_submenu: function (target) {
    $(".header").addClass("submenu-open");
    target.find(".menu-container.level-1").addClass("open");
    $(".submenu-mobile-header").addClass("visible");
    $(".menu-mobile-header > .bt-close").addClass("invisible");

    if (target.find(".menu-container.level-1").find('.menu-link').length) {
      var text = target.find(".menu-container.level-1").find(".menu-link-title").html();
      var url = target.find(".menu-container.level-1").find(".menu-link-url").html();
      $(".submenu-header-link").addClass("visible");
      Menu.change_link_header(text, url);
    }
  },
  close_submenu: function () {
    $(".header").removeClass("submenu-open");
    $(".menu-container.level-1").removeClass("open");
    $(".submenu-mobile-header").removeClass("visible");
    $(".menu-mobile-header > .bt-close").removeClass("invisible");
    $('.submenu-header-link').removeClass("visible");
    Menu.change_link_header('','');
  },
  change_link_header: function (text, url) {
    $(".submenu-header-link a .text").text(text);
    $(".submenu-header-link a").attr("href", url);
  },
  resize: function () {
    /*$("html").removeClass("menu-open");
		$("body").removeClass("no-scroll");
		$(".header").removeClass("open");*/
  },
};
